require('dom-slider');
const $ = jQuery.noConflict();
const { slideToggle, slideUp, slideDown } = window.domSlider;

const accordionButtons = document.querySelectorAll(
	'.block-accordion-item > .wp-block-button .wp-block-button__link'
);

const accordionWithLoadMore = document.querySelectorAll(
	'.block-accordion-centered.with-load-more'
);

const accordionItems = document.querySelectorAll('.block-accordion-item');

const toggleAccordion = (e) => {
	e.preventDefault();

	const currentItem = e.currentTarget.closest('.block-accordion-item');
	const accordionBlock = e.currentTarget.closest('.block-accordion');

	if (currentItem && accordionBlock) {
		currentItem.classList.toggle('active');
		e.currentTarget.classList.toggle('active');

		const currentContent = currentItem.querySelector(
			'.block-accordion-item > .block-accordion-item__inner'
		);

		slideToggle({
			element: currentContent,
			slideSpeed: 400,
			easing: 'ease-in-out',
		});

		if (accordionBlock.classList.contains('is-style-single-open')) {
			const activeItemContents = accordionBlock.querySelectorAll(
				'.block-accordion-item.active > .block-accordion-item__inner'
			);

			if (activeItemContents.length) {
				activeItemContents.forEach((activeItemContent) => {
					if (activeItemContent !== currentContent) {
						activeItemContent.parentElement.classList.remove(
							'active'
						);

						slideUp({
							element: activeItemContent,
							slideSpeed: 400,
							easing: 'ease-in-out',
						});
					}
				});
			}
		}
	}
};

const onlyOpenAccordion = (e) => {
	e.preventDefault();

	const currentItem = e.currentTarget.closest('.block-accordion-item');
	const accordionBlock = e.currentTarget.closest('.block-accordion');

	if (currentItem && accordionBlock) {
		// Always add 'active' class
		currentItem.classList.add('active');
		e.currentTarget.classList.add('active');

		const currentContent = currentItem.querySelector(
			'.block-accordion-item > .block-accordion-item__inner'
		);

		slideDown({
			element: currentContent,
			slideSpeed: 400,
			easing: 'ease-in-out',
		});

		if (accordionBlock.classList.contains('is-style-single-open')) {
			const activeItemContents = accordionBlock.querySelectorAll(
				'.block-accordion-item.active > .block-accordion-item__inner'
			);

			if (activeItemContents.length) {
				activeItemContents.forEach((activeItemContent) => {
					if (activeItemContent !== currentContent) {
						activeItemContent.parentElement.classList.add('active');

						slideDown({
							element: activeItemContent,
							slideSpeed: 400,
							easing: 'ease-in-out',
						});
					}
				});
			}
		}
	}
};

const accordion = () => {
	if (accordionButtons.length) {
		accordionButtons.forEach((accordionButton) => {
			accordionButton.addEventListener('click', toggleAccordion);
		});
	}

	if (accordionItems.length) {
		accordionItems.forEach((accordionItem) => {
			if (accordionItem.classList.contains('is-style-open')) {
				const accordionButton = accordionItem.querySelector(
					'.block-accordion-item > .wp-block-button .wp-block-button__link'
				);

				if (accordionButton) {
					accordionButton.classList.add('active');
				}

				accordionItem.classList.add('active');
			} else {
				const accordionContent = accordionItem.querySelector(
					'.block-accordion-item > .block-accordion-item__inner'
				);

				if (accordionContent) {
					slideUp({
						element: accordionContent,
						slideSpeed: 0,
					});
				}
			}
		});
	}

	// load more.
	if (accordionWithLoadMore.length) {
		accordionWithLoadMore.forEach((theAccordions) => {
			const accordionCount = theAccordions.querySelectorAll(
				'.block-accordion-item'
			).length;

			if (accordionCount > 5) {
				let startingCount = 5;
				const thisAccordionBtn = theAccordions.querySelector(
					'.block-accordion-centered__btn-con'
				);
				// display load more button.
				thisAccordionBtn.classList.add('display');
				// load more on button click.
				thisAccordionBtn.addEventListener('click', function () {
					startingCount += 4;

					theAccordions
						.querySelectorAll(
							`.block-accordion-item:nth-child(-n+${startingCount})`
						)
						.forEach((accordionItem) => {
							accordionItem.classList.add('display');
						});

					if (startingCount >= accordionCount) {
						thisAccordionBtn.classList.remove('display');
					}
				});
			}
		});
	}

	// Add state for 'expand-all-days' button.
	let expandAllState = 'expand';

	$('.expand-all-days').on('click', function () {
		// If state is 'expand', expand all accordions.
		if (expandAllState === 'expand') {
			$(
				'.trip-itinerary .block-accordion-item > .wp-block-button .wp-block-button__link'
			).each(function () {
				const event = $.Event('click');
				event.currentTarget = this;
				onlyOpenAccordion(event);
			});

			// Change button text and update state.
			$(this).text('Close all days');
			expandAllState = 'collapse';
		}
		// If state is 'collapse', collapse all accordions.
		else {
			$(
				'.trip-itinerary .block-accordion-item > .wp-block-button .wp-block-button__link'
			).each(function () {
				const event = $.Event('click');
				event.currentTarget = this;
				const currentItem = event.currentTarget.closest(
					'.block-accordion-item'
				);
				const currentContent = currentItem.querySelector(
					'.block-accordion-item > .block-accordion-item__inner'
				);

				// Remove 'active' class
				currentItem.classList.remove('active');
				event.currentTarget.classList.remove('active');

				slideUp({
					element: currentContent,
					slideSpeed: 400,
					easing: 'ease-in-out',
				});
			});

			// Change button text and update state.
			$(this).text('Expand all days');
			expandAllState = 'expand';
		}
	});
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		accordion();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};

export { controller, toggleAccordion };
